import { api } from '@/lib/api';
import type { CreateContactRequest, ContactResponse, ContactQuery, ContactListResponse } from '@troia-v3/types';

export const contactsService = {
  /**
   * Busca lista de contatos com filtros e paginação
   */
  async getContacts(query?: ContactQuery): Promise<ContactListResponse> {
    const response = await api.get('/contacts', { params: query });
    return response.data.data;
  },

  /**
   * Cria um novo contato
   */
  async createContact(data: CreateContactRequest): Promise<ContactResponse> {
    const response = await api.post('/contacts', data);
    return response.data.data;
  },

  /**
   * Busca um contato por ID
   */
  async getContactById(id: string): Promise<ContactResponse> {
    const response = await api.get(`/contacts/${id}`);
    return response.data.data;
  },

  /**
   * Atualiza um contato existente
   */
  async updateContact(id: string, data: Partial<CreateContactRequest>): Promise<ContactResponse> {
    const response = await api.put(`/contacts/${id}`, data);
    return response.data.data;
  },

  /**
   * Deleta um contato
   */
  async deleteContact(id: string): Promise<void> {
    await api.delete(`/contacts/${id}`);
  },

  /**
   * Bloqueia um contato (2026-09-01)
   */
  async blockContact(id: string): Promise<ContactResponse> {
    const response = await api.post(`/contacts/${id}/block`);
    return response.data.data;
  },

  /**
   * Desbloqueia um contato (2026-09-01)
   */
  async unblockContact(id: string): Promise<ContactResponse> {
    const response = await api.post(`/contacts/${id}/unblock`);
    return response.data.data;
  }
};
